/** @jsx jsx */
import { Flex, Grid, Text } from '@bottlebooks/gatsby-design-system';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import { CallToAction, Section } from '..';
import CardBlock from '../Blocks/CardBlock';
import IconBlock from '../Blocks/IconBlock';
import ImageBlock from '../Blocks/ImageBlock';
import TextBlock from '../Blocks/TextBlock';
import TitleBlock from '../Blocks/TitleBlock';
import VideoBlock from '../Blocks/VideoBlock';

export default function SimpleGridSystem({
  title,
  blocks = [],
  style,
  callToAction,
}) {
  return (
    <Section variant={style.variant} sx={style}>
      {title && (
        <Section.Title
          sx={{ textAlign: style.alignment || 'left', marginBottom: 4 }}
        >
          {title}
        </Section.Title>
      )}
      <Section.Body>
        <Grid
          columns={[1, null, blocks?.length]}
          gap={4}
          sx={{ gridTemplateColumns: 'repeat(1fr)' }}
        >
          {blocks?.map((block) => {
            const width = [
              480,
              null,
              960 / blocks.length,
              1170 / blocks.length,
            ];
            switch (block.__typename) {
              case 'CardBlock':
              case 'SanityCardBlock':
                return <CardBlock key={block._key} {...block} width={width} />;

              case 'IconBlock':
              case 'SanityIconBlock':
                return <IconBlock key={block._key} {...block} />;

              case 'TextBlock':
              case 'SanityTextBlock':
                return <TextBlock key={block._key} {...block} />;

              case 'TitleBlock':
              case 'SanityTitleBlock':
                return <TitleBlock key={block._key} {...block} />;

              case 'ImageBlock':
              case 'SanityImageBlock':
                return <ImageBlock key={block._key} {...block} width={width} />;
              case 'VideoBlock':
              case 'SanityVideoBlock':
                return <VideoBlock key={block._key} {...block} />;
              default:
                return <Text>Not supported</Text>;
            }
          })}
        </Grid>
        <Flex align="center" justify="center">
          <CallToAction
            {...callToAction}
            sx={{ marginTop: 5, marginBottom: 2 }}
          />
        </Flex>
      </Section.Body>
    </Section>
  );
}

export const fragment = graphql`
  fragment SanitySimpleGridSectionFragment on SanitySimpleGridSection {
    title
    callToAction {
      ...CallToAction
    }
    blocks {
      ... on SanityCardBlock {
        _key
        ...SanityCardBlockFragment
      }
      ... on SanityIconBlock {
        _key
        ...SanityIconBlockFragment
      }
      ... on SanityTextBlock {
        _key
        ...SanityTextBlockFragment
      }
      ... on SanityTitleBlock {
        _key
        ...SanityTitleBlockFragment
      }
      ... on SanityImageBlock {
        _key
        ...SanityImageBlockFragment
      }
      ... on SanityVideoBlock {
        _key
        ...SanityVideoBlockFragment
      }
    }
    style {
      ...SectionStyle
    }
  }
`;
